import type { BindingUpsertRequest, FieldMappingProfile, SyncBinding } from '../../api/types';

/**
 * Bygger en fullstendig {@link BindingUpsertRequest} fra en eksisterende binding.
 *
 * En PUT erstatter hele bindingen. Utelates felt-mapping-profilen, kjører API-et preflight
 * på nytt og genererer en fersk profil — som stille kan overskrive korreksjoner operatøren
 * har gjort. Derfor sender vi alltid den lagrede profilen (og editor-feltene) med, slik at
 * enkle endringer som «aktiver/deaktiver» eller nytt visningsnavn er trygge.
 */
export function toUpsertRequest(
    binding: SyncBinding,
    overrides: Partial<BindingUpsertRequest> = {},
): BindingUpsertRequest {
    return {
        bindingId: binding.bindingId,
        displayName: binding.displayName,
        forvaltningssystem: binding.forvaltningssystem,
        centralDatasetId: binding.centralDatasetId,
        agolBaseUrl: binding.agolBaseUrl,
        lokalIdField: binding.lokalIdField,
        enabled: binding.enabled,
        mappingProfile: parseMappingProfile(binding.mappingProfileJson),
        agolEditorField: binding.agolEditorField,
        agolEditDateField: binding.agolEditDateField,
        // Sendes alltid eksplisitt; API-et ville arvet den ved utelatelse, men det skal ikke
        // være klientens jobb å stole på.
        directionPolicy: binding.directionPolicy,
        ...overrides,
    };
}

/** Parser den serialiserte mapping-profilen; null hvis den mangler eller er ugyldig. */
export function parseMappingProfile(json: string | null | undefined): FieldMappingProfile | null {
    if (!json) return null;
    try {
        return JSON.parse(json) as FieldMappingProfile;
    } catch {
        return null;
    }
}
